import { render, staticRenderFns } from "./helpDocumentation.vue?vue&type=template&id=5ccd1d04&scoped=true"
import script from "./helpDocumentation.vue?vue&type=script&lang=js"
export * from "./helpDocumentation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccd1d04",
  null
  
)

export default component.exports